import getAxiosInstance from '../../../../../../helpers/get_axios_instance'
import lrsAdapter from '../../../../../../helpers/lrs_adapter'

export class TablaCamionesCaladosService {
  static async getDataCamionesCalados () {
    const axios = getAxiosInstance()
    return axios.get('/consulta_calado_aceptado_listado').then(lrsAdapter, lrsAdapter)
      .then(result => result.data)
  }

  static async getDataCamionesCaladosAutorizados () {
    const axios = getAxiosInstance()
    return axios.get('/consulta_calado_aceptado_autorizado_listado').then(lrsAdapter, lrsAdapter)
      .then(result => result.data)
  }
}
